import {IDisposableObject} from "../../../../../utils/disposable-object.interface";

export class PixiAsset<T = any> implements IDisposableObject {
    constructor(
        public readonly rawAsset: T,
        private readonly disposeResource: (res: PixiAsset<T>) => void
    ) {}

    dispose() {
        this.disposeResource(this);
    }
}
